export default __webpack_public_path__ + "static/media/meeting.d806e7d0.svg";